import { useState } from 'react'
import cn from 'classnames'
import { ArrowListExpand } from '@/utils/icons'
import AccessLevelControl from '../AccessLevelControl/AccessLevelControl'
import {
  getAccessActionKey,
  getAggregateAccessControl,
  supportsContentOnly,
} from '../../utils/access'
import { getThemeProgress } from '../../utils/progress'
import { AccessColumn, ThemeRowProps } from '../../utils/types'
import styles from '../../index.module.css'

const ThemeRow = ({
  theme,
  children,
  accessDisabled,
  pendingActionKey,
  onAccessChange,
}: ThemeRowProps) => {
  const [isOpen, setIsOpen] = useState(false)

  const renderAccessControl = (column: AccessColumn) => {
    // у контрольной и пробника нет режима «только контент» — клетка пустая
    if (column === 'materials' && !supportsContentOnly(theme.work_type)) {
      return <div className={styles.emptyActionCell} />
    }

    const value = getAggregateAccessControl(theme.access_summary, column)
    const actionKey = getAccessActionKey('theme', theme.id, column)
    const tooltip =
      column === 'materials'
        ? 'Открыть / закрыть материалы всех уроков темы'
        : 'Открыть / закрыть выполнение заданий во всех уроках темы'

    return (
      <AccessLevelControl
        state={value.state}
        disabled={value.disabled || accessDisabled}
        loading={pendingActionKey === actionKey}
        tooltip={tooltip}
        ariaLabel={tooltip}
        onClick={() =>
          onAccessChange({
            entityType: 'theme',
            entityId: theme.id,
            entityName: theme.name,
            column,
            state: value.state,
          })
        }
      />
    )
  }

  return (
    <>
      <div
        className={styles.row}
        onClick={() => setIsOpen((value) => !value)}
      >
        <div
          className={cn(styles.cell, styles.themeCell, styles.themeNameCell)}
        >
          <span className={styles.rowTitle}>
            <span className={styles.themeLabel}>Тема:</span> {theme.name}
          </span>
          <span
            className={cn(styles.expandIcon, isOpen && styles.expandIconOpen)}
          >
            <ArrowListExpand />
          </span>
        </div>
        <div className={cn(styles.cell, styles.themeCell, styles.center)}>
          {getThemeProgress(theme.lessons)} %
        </div>
        {renderAccessControl('materials')}
        {renderAccessControl('tasks')}
        <div className={styles.emptyActionCell} />
      </div>
      {isOpen && children}
    </>
  )
}

export default ThemeRow
